// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260914.1789413823/static/js/" + chunkId + "." + {"249":"0a739b7b","463":"e80118b9"}[chunkId] + ".chunk.js";
};